import { $, $$ } from '@3pc/dom';

async function initDatePicker(element) {
  const { default: flatpickr } = await import(
    /* webpackChunkName: 'flatpickr' */ 'flatpickr'
  );
  const { default: locale } = await import(
    /* webpackChunkName: 'flatpickrLocale' */ 'flatpickr/dist/l10n/de'
  );
  const lang = document.documentElement.lang.split('-')[0];

  // Modify the <input type="hidden" coming from package, causing validation errors
  const setInputHidden = () => {
    const listInputHidden = $$('input#searchform-minimum-date');

    if (listInputHidden.length) {
      listInputHidden.forEach(input => {
        input.type = 'text';
        input.classList.add('searchform__input-js-hidden');
      });
    }
  };

  const enhanceFlatpickrAccessibility = () => {
    const nodelistFlatpickrInput = document.querySelectorAll(
      '.searchform [data-flatpickr] + input'
    );

    nodelistFlatpickrInput.forEach(input => {
      if (input.placeholder) {
        input.setAttribute('aria-label', input.placeholder);
        input.setAttribute('tabindex', '0');
      }
    });
  };

  const handleFlatpickrReady = () => {
    enhanceFlatpickrAccessibility();
    setInputHidden();
  };

  flatpickr(element, {
    altInput: true,
    altFormat: 'd.m.Y',
    dateFormat: 'Y-m-d',
    locale: locale[lang],
    onReady: handleFlatpickrReady,
  });
}

$$('.searchform [data-flatpickr]').forEach(initDatePicker);

// Indexed Search Pagination
const searchForm = $('form.searchform');
const pageInput = $('#tx_indexedsearch_pointer');

if (searchForm && pageInput) {
  $$('.pagination a[data-page]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      pageInput.value = parseInt(link.dataset.page) - 1;
      searchForm.submit();
    });
  });
}

// On loaded search results, redirect the focus on first link
const targetNode = document.querySelector('body');
const config = { childList: true, subtree: true };

const redirectFocus = () => {
  const nodeSearchResult = $('.search-list');

  if (nodeSearchResult) {
    const linkSearchResult = $('a', nodeSearchResult);
    linkSearchResult.focus();
  }
};

const callback = () => {
  redirectFocus();
};

const observer = new MutationObserver(callback);
observer.observe(targetNode, config);
